const removeWaterMark = {
  ExportVideoWithoutWaterMark: 'تصدير الفيديو بدون علامة HitPaw',
  ExportWithoutLimits: 'تصدير الفيديو بدون العلامة المائية HitPaw',
  MaximumUpload500MB: 'حجم ملف الرفع الأقصى: 500MB',
  watermarkRemoveTitle: 'إزالة العلامة المائية من الفيديو أون لاين HitPaw',
  DiscountPrice: '$0.99',
  WeekTotalPrice: '$4.49',

  MonthWeekPrice: '$1.75',
  MonthTotalPrice: '$6.99',

  YearWeekPrice: '$0.87',
  YearTotalPrice: '$41.88',
  Day: 'Day',
  Weekly: 'أسبوعي',
  Monthly: 'شهري',
  Yearly: 'سنوي',
  week: 'أسبوع',
};

export default removeWaterMark;
